import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import RadioButton from './RadioButton';

const CheckGroup = ({
  wrapper: Wrapper,
  name,
  options,
  label,
  itemComponent: Item,
  wrapperClassName,
  onChange,
  value,
}) => (
  <Wrapper className={classNames('mb-2', wrapperClassName)}>
    <div className="font-roboto text-xl mb-4 block">{label}</div>
    {options.map(option => (
      <Item
        key={option.value}
        {...option}
        name={name}
        checked={option.value === value}
        onChange={onChange}
      />
    ))}
  </Wrapper>
);

CheckGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ),
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  wrapper: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func]),
  itemComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func]),
  wrapperClassName: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

CheckGroup.defaultProps = {
  wrapper: ({ children, className }) => <div className={className}>{children}</div>,
  itemComponent: RadioButton,
};

export default CheckGroup;
